import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ingredients: [],
  confirmOpen: false,
};

const ingredientsListSlice = createSlice({
  name: "ingredientsList",
  initialState,
  reducers: {
    addIngredient: (state, action) => {
      if (!state.ingredients.includes(action.payload)) {
        state.ingredients.push(action.payload);
      }
    },
    removeIngredient: (state, action) => {
      state.ingredients = state.ingredients.filter((i) => i !== action.payload);
    },
    clearIngredients: (state) => {
      state.ingredients = [];
    },
    setConfirmOpen: (state, action) => {
      state.confirmOpen = action.payload;
    },
  },
});

export const {
  addIngredient,
  removeIngredient,
  clearIngredients,
  setConfirmOpen,
} = ingredientsListSlice.actions;
export default ingredientsListSlice.reducer;
